import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import $ from "jquery";
const uuidv4 = require('uuid/v4')
import CalendarEventEdit from '../components/CalendarEventEditComponent';
import { getEventName } from '../../name-helpers/eventNameHelper';

class CalendarModal extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            modalId: this.props.modalId || 'edit-calendar-modal-' + uuidv4(),

            calendarEventId: this.props.calendarEventId || '',
            location: this.props.location || null,

            invoiceId: this.props.invoiceId || '',
            quoteId: this.props.quoteId || '',
            orderId: this.props.orderId || '',
            //projectId of invoice/quote/order reference
            projectId: this.props.projectId || '',
            project: this.props.project || null,
            identifier: this.props.identifier || '',

            contactId: this.props.contactId || '',
            userId: this.props.userId || '',

            showingEventForm: false,
        }

        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(event) {
        if (event && event.preventDefault) {
            event.preventDefault()
        }
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    render() {
        let modalDialogClassName = "modal-dialog modal-xl modal-dialog-scrollable h-100"
        if (this.state.showingEventForm) {
            modalDialogClassName = "modal-dialog modal-md modal-dialog-scrollable"
        }

        return <div className="modal fade calendar-modal"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="calendarModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className={modalDialogClassName} role="document">
                <div className="modal-content h-100">

                    <div className="modal-header">
                        <h5 className="modal-title mb-0 border-0 pb-0" id="calendarModalTitle">
                            {!this.state.calendarEventId ?
                                <FormattedMessage
                                    id="calendar.new_event.create_header"
                                    defaultMessage="Create a new calendar {eventName}"
                                    values={{ eventName: getEventName(this.props.intl) }}
                                /> :
                                <FormattedMessage
                                    id="calendar.edit_event_header"
                                    defaultMessage="Edit calendar {eventName}"
                                    values={{ eventName: getEventName(this.props.intl) }}
                                />
                            }
                        </h5>
                        <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body overflow-hidden">
                        <div className="container-fluid h-100">
                            <CalendarEventEdit
                                calendarEventId={this.state.calendarEventId}
                                projectId={this.state.projectId}
                                project={this.state.project}
                                identifier={this.state.identifier}
                                proposal={this.props.proposal}
                                invoiceId={this.state.invoiceId}
                                quoteId={this.state.quoteId}
                                orderId={this.state.orderId}
                                providedContactId={this.state.contactId}
                                userId={this.state.userId}
                                onSave={this.closeModal}

                                location={this.props.location}
                                initialStep={1}
                                lastStep={2}
                                onShowEventForm={(showingEventForm) => {
                                    this.setState({
                                        showingEventForm: showingEventForm,
                                    })
                                }}
                            >
                                <button
                                    className="btn btn-secondary mr-2"
                                    onClick={this.closeModal}
                                >
                                    <FormattedMessage
                                        id="calendar.new_event.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                            </CalendarEventEdit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(CalendarModal)



// WEBPACK FOOTER //
// ./src/calendar/modals/CalendarModal.component.jsx